import api from '../../config/APIConfig';

const { iAxios, apiUri } = api;

const baseUrl = `${apiUri}/v1`;

export const PlanCompraActions = {
    PlanCompra
    ,ActividadEconomica
    ,valPlanCodDescuento
}
function PlanCompra(codigo,aplicaToken) {
    return iAxios.get(`${baseUrl}/PlanCompra?codigo=`+codigo+'&aplicaToken='+aplicaToken)
}
function ActividadEconomica() {
    return iAxios.get(`${baseUrl}/ActividadEconomica`)
}
function valPlanCodDescuento(descuentoRequest) {
    return iAxios.post(`${baseUrl}/valCodDescuento`,descuentoRequest)
}